import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { AxsHeroComponent } from '@vanguard/axs-angular';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

@Component({
  selector: 'hero-v4',
  standalone: true,
  imports: [AxsHeroComponent, CommonModule],
  templateUrl: './hero-v4.component.html',
  styleUrl: './hero-v4.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HeroV4Component implements OnInit {
  heroContent = content.Data.v4_rcc_root.content.hero;

  constructor(private readonly contentService: ContentService) {}

  ngOnInit(): void {
    console.log('V4 Hero Component Initialized');
    // Get V4 content from v4_rcc_root structure
    this.contentService.getContent().subscribe((data) => {
      this.heroContent = data.Data.v4_rcc_root.content.hero;
    });
  }
}
